import Chart from 'src/componentes/chart';
import PerguntaMetadados from './PerguntaMetadados';
import { EMPTY_STATE_CLASS_NAME, getOptionColor, toNumber } from './utils';

function GraficoBarrasOpcoes({ intl, opcoes, pergunta }) {
  const possuiRespostas = opcoes.some(
    (opcao) => toNumber(opcao.quantidade) > 0
  );
  const data = opcoes.map((opcao, index) => {
    const quantidade = intl.formatNumber(toNumber(opcao.quantidade));
    const percentual = intl.formatNumber(toNumber(opcao.percentual), {
      maximumFractionDigits: 2,
    });
    const resultado = `${percentual}% · ${quantidade} ${intl.formatMessage({
      id: 'labelRespostas',
    })}`;

    return {
      color: getOptionColor(opcao, index),
      displayValue: resultado,
      label: opcao.texto,
      toolText: `${opcao.texto}: ${resultado}`,
      value: toNumber(opcao.percentual),
    };
  });

  return (
    <div className="tw:min-w-0 tw:px-5 tw:pt-3.5 tw:pb-5">
      <PerguntaMetadados intl={intl} pergunta={pergunta} />
      {possuiRespostas ? (
        <div aria-label={pergunta.titulo} className="tw:min-w-0" role="img">
          <Chart
            containerBackgroundOpacity="0"
            dataFormat="json"
            dataSource={{
              chart: {
                animation: '0',
                bgAlpha: '0',
                canvasBgAlpha: '0',
                chartBottomMargin: '8',
                chartLeftMargin: '0',
                chartRightMargin: '16',
                chartTopMargin: '16',
                decimals: '2',
                formatNumberScale: '0',
                labelFontColor: '#344054',
                labelFontSize: '13',
                maxBarHeight: '28',
                maxLabelWidthPercent: '35',
                numberSuffix: '%',
                placeValuesInside: '0',
                plotSpacePercent: '45',
                showAlternateVGridColor: '0',
                showBorder: '0',
                showCanvasBorder: '0',
                showPlotBorder: '0',
                showValues: '1',
                theme: 'fusion',
                usePlotGradientColor: '0',
                valueFontColor: '#667085',
                valueFontSize: '12',
                yAxisMaxValue: '100',
                yAxisMinValue: '0',
              },
              data,
            }}
            height={Math.max(240, opcoes.length * 56 + 64)}
            type="bar2d"
            width="100%"
          />
        </div>
      ) : (
        <div className={EMPTY_STATE_CLASS_NAME}>
          {intl.formatMessage({ id: 'labelNenhumaRespostaParaExibir' })}
        </div>
      )}
    </div>
  );
}

export default GraficoBarrasOpcoes;
